import { useEffect, useMemo, useState } from "react";
import {
  isMoreThan24HoursAgo,
  formatEventDate,
  formatScheduleEventRange,
} from "../../../helpers";
import { useScheduleEventStore } from "../../hooks";
import { SecondaryButton, MainButton, MainButtonOutline } from "../../ui";

export const AssessmentEventsCard = ({ handleSelectEventToReschedule }) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    scheduleEvents,
  } = useScheduleEventStore();

  // States ------------------------------------------------//
  const filteredEvents = useMemo(() => {
    return scheduleEvents.filter(
      (event) =>
        event.type === "INITIAL_ASSESSMENT" || event.type === "FINAL_ASSESSMENT"
    );
  }, [scheduleEvents]);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  return (
    <>
      {filteredEvents.length > 0 && (
        <div className="d-flex align-items-center">
          <h5 className="mb-0">Tus sesiones agendadas</h5>
        </div>
      )}

      {filteredEvents.map((scheduleEvent, index) => (
        <div key={scheduleEvent.id} className="card border">
          <div className="card-body">
            <div className="vstack gap-3">
              <h5 className="mb-0">
                Sesión {index + 1} (
                {formatScheduleEventRange(
                  scheduleEvent.start,
                  scheduleEvent.end
                )}
                )
              </h5>
              <p className="mb-0">
                <b>Título: </b>
                {scheduleEvent.title}
              </p>

              {scheduleEvent.attended !== null && (
                <p className="mb-0">
                  <b>Asistencia: </b>
                  {scheduleEvent.attended ? "Asistió" : "No asistió"}
                </p>
              )}
              {scheduleEvent.attended === null && (
                <div>
                  <a
                    target="_blank"
                    href={scheduleEvent.notes}
                    className="btn btn-primary px-2-5 py-1-5 me-2"
                  >
                    Ingresar
                  </a>
                  <MainButtonOutline
                    type="button"
                    disabled={
                      scheduleEvent.attended !== null ||
                      isMoreThan24HoursAgo(scheduleEvent.start)
                    }
                    onClick={() => {
                      handleSelectEventToReschedule(scheduleEvent);
                    }}
                  >
                    Reagendar
                  </MainButtonOutline>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
